import * as yup from 'yup'
import { defineMessages, IntlShape } from 'react-intl'
import { isEmpty } from 'lodash'

const companyMessages = defineMessages({
  required: {
    id: 'loyalty.campaigns.form.company.required',
    defaultMessage: 'The company is required'
  }
})

const nameMessages = defineMessages({
  required: {
    id: 'loyalty.campaigns.form.name.required',
    defaultMessage: 'The name is required'
  },
  max: {
    id: 'loyalty.campaigns.form.name.max',
    defaultMessage: 'The name can be up to 150 characters'
  },
  min: {
    id: 'loyalty.campaigns.form.name.min',
    defaultMessage: 'The name must be at least 2 characters long'
  }
})

const lineMessages = defineMessages({
  required: {
    id: 'loyalty.campaigns.form.line.required',
    defaultMessage: 'The line is required'
  }
})

const startAtMessages = defineMessages({
  required: {
    id: 'loyalty.campaigns.form.startAt.required',
    defaultMessage: 'The starting date is required'
  }
})

const endAtMessages = defineMessages({
  required: {
    id: 'loyalty.campaigns.form.endAt.required',
    defaultMessage: 'The ending date is required'
  }
})

const descriptionMessages = defineMessages({
  max: {
    id: 'loyalty.campaigns.form.description.max',
    defaultMessage: 'The description cannot be longer than 500 characters'
  },
  min: {
    id: 'loyalty.campaigns.form.description.min',
    defaultMessage: 'The description must be at least 2 character long'
  }
})

const testCompanyIsRequired = (value?: string): boolean => {
  return !isEmpty(value)
}

export const schema = (intl: IntlShape): yup.AnyObjectSchema => {
  return yup.object().shape({
    company: yup.object().shape({
      id: yup.string().test('is-company-required', intl.formatMessage(companyMessages.required), function (value) {
        return testCompanyIsRequired(value)
      })
    }),
    name: yup
      .string()
      .required(intl.formatMessage(nameMessages.required))
      .max(150, intl.formatMessage(nameMessages.max))
      .min(2, intl.formatMessage(nameMessages.min)),

    startAt: yup.string().required(intl.formatMessage(startAtMessages.required)),
    endAt: yup.string().required(intl.formatMessage(endAtMessages.required)),
    description: yup
      .string()
      .max(500, intl.formatMessage(descriptionMessages.max))
      .min(2, intl.formatMessage(descriptionMessages.min)),

    companyLines: yup.array().min(1, intl.formatMessage(lineMessages.required))
  })
}
